import React, { useMemo } from 'react';

import styled from '@mint-lib/styled';
import { useTheme } from '@mint-lib/theme';
import SvgIconM, { SvgIconProps } from '@mui/material/SvgIcon';

import {
  IconLoadingState,
  useLazyLoadedIcon,
} from '../../hooks/useLazyLoadedIcon.js';

type IconComponentType =
  | 'ChannelAddressableTv'
  | 'ChannelDisplay'
  | 'ChannelAdserver'
  | 'ChannelSearch'
  | 'ChannelNative'
  | 'ChannelSocial'
  | 'ChannelNetwork'
  | 'ChannelVideo'
  | 'ChannelOfflineTv'
  | 'ChannelOfflineRadio'
  | 'ChannelOoh'
  | 'ChannelDem'
  | 'ChannelDooh'
  | 'ChannelDmp'
  | 'ChannelMobile'
  | 'ChannelDsp'
  | 'ChannelProgrammaticRadio'
  | 'ChannelPublisher'
  | 'ChannelWebAnalytics'
  | 'ChannelBrandSafety'
  | 'ChannelChatBot'
  | 'ChannelInfluencerMarketing'
  | 'ChannelBrandedContent'
  | 'ChannelAffiliation'
  | 'ChannelMetasearch'
  | 'ChannelPayTv'
  | 'ChannelPromocode'
  | 'ChannelMgm'
  | 'ChannelDirect'
  | 'ChannelEvents'
  | 'ChannelNewspaper'
  | 'ChannelMagazine'
  | 'ChannelCinema'
  | 'ChannelDirectMedia'
  | 'ChannelPaidProgrammatic'
  | 'ChannelRetail';

// @ts-ignore
export interface ChannelIconProps extends SvgIconProps {
  component: IconComponentType;
}

const ChannelIcon = ({ component, ...props }: ChannelIconProps) => {
  const theme = useTheme();
  const mode = theme.palette.mode;

  const componentName = useMemo(() => {
    const modeSuffix = mode.charAt(0).toUpperCase() + mode.slice(1);
    return `${component}${modeSuffix}`;
  }, [component, mode]);
  // @ts-ignore
  const { SvgIcon, state } = useLazyLoadedIcon(componentName);

  return (
    <StyledIcon
      role="img"
      // @ts-ignore Tsgo doesn't allow unknown props
      alt={state === IconLoadingState.Loaded ? componentName : ''}
      aria-hidden={state !== IconLoadingState.Loaded}
      {...props}
      aria-label={
        state === IconLoadingState.Loaded ? props['aria-label'] : undefined
      }
      inheritViewBox
      // @ts-ignore
      component={SvgIcon}
    />
  );
};

export default ChannelIcon;

export const StyledIcon = styled(SvgIconM)({
  width: '16px',
  height: '16px',
  fontSize: '16px',
});
